// Presence, not truthiness: Yes/No tags store canonical booleans and Number
// tags can be 0, so `false`/`0` are valid supplied values; only undefined,
// null, or '' count as missing.
export function missingMandatoryAttributes(attributeColumns, values) {
  const supplied = values || {};
  return (attributeColumns || [])
    .filter((col) => col.mandatory === true && (
      supplied[col.name] === undefined
      || supplied[col.name] === null
      || supplied[col.name] === ''
    ))
    .map((col) => col.name)
    .sort();
}

export function tagsToValueMap(selectedTags) {
  const map = {};
  (selectedTags || []).forEach((tag) => { map[tag.category] = tag.value; });
  return map;
}

// Allocation writes profile defaults with the upload's explicit values on top.
// Approval must check that same merged set, including explicit empty overrides.
export function allocationAttributes(profile, file) {
  return { ...(profile?.default_tags || {}), ...(file?.pack_attributes || {}) };
}
